<!--
    校区管理-校区列表-配置账号数量
    作用：配置校区可上课权限的账号数量
    组件：el-dialog
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="配置账号数量"
      width="650px"
    >
      <div class="content">
        <div class="mian-title">
          <span class="item">校区名称：{{ item.review_used.name }}</span>
          <span class="item">校区代码：{{ item.school_code }}</span>
        </div>
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          class="form">
          <el-form-item
            label="账号数量配置："
            prop="user_count"
            label-width="130px">
            <el-input v-model="form.user_count"/>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          class="mr-10"
          @click="handleClose">取消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="submitData()">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SetAccountNum',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    const validNum = (rule, value, callback) => {
      const reg = /^[1-9]\d*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正整数！'));
      }
    };
    return {
      loading: false,
      form: { user_count: null },
      rules: {
        user_count: [
          { required: true, message: '请输入账号数', trigger: 'blur' },
          { validator: validNum, trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.form.user_count = this.item.user_count;
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog');
    },
    submitData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http.patch(`/api/service/operate/clients/${this.item.id}`, this.form).then(() => {
            this.$emit('close-dialog');
            this.$emit('refresh-data');
            this.$message.success('配置账号数量成功！');
          }).catch((err) => {
            this.$message.error(err.message);
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mian-title{
  padding: 0 20px;
  margin-bottom: 30px;
  .item{
    display: inline-block;
    margin-right: 15px;
  }
}
.form{
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/dialog/setAccountNum.vue